module.exports = __webpack_public_path__ + "static/b-centro-cirurgico-f7b209f6c62b4e3b77077703efe1ef70.jpg";